var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H2C1.44772 11 1 10.5523 1 10V2C1 1.44772 1.44772 1 2 1H4.90548C5.27189 1 5.60897 1.2004 5.784 1.5223L6.341 2.54666C6.51603 2.86857 6.85311 3.06897 7.21952 3.06897H12C12.5523 3.06897 13 3.51668 13 4.06897V10C13 10.5523 12.5523 11 12 11Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOutlined);
export default __webpack_public_path__ + "static/media/folder-outlined.c40277511c51d43e88ed010ea7c498ce.svg";
export { ForwardRef as ReactComponent };